module.exports = __webpack_public_path__ + "static/media/blog2.437f0388.jpg";